<template>
  <v-data-table :headers="headers" :items="releaseNoteList" :items-per-page="5" class="elevation-0" dense item-key="id">
    <template v-slot:item="{ item }">
      <tr>
        <td>{{ item.id }}</td>
        <td>
          <router-link :to="`/pack/${item.packId}/releaseNote/${item.id}/view`" data-cy="releaseNoteLink">{{
            item.title
          }}</router-link>
        </td>
      </tr>
    </template></v-data-table
  >
</template>

<script>
export default {
  data() {
    return {
      headers: [{ text: "ID", align: "start", value: "id", width: "4.25rem" }, { text: "Title", value: "title" }],
    };
  },
  props: {
    releaseNoteList: { required: true, type: Array },
  },
};
</script>
